export default {"src":"/_next/static/media/WhoWeAre_005A.637dc6c3.JPG","height":688,"width":1920};